import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, PackageIcon, TrendingUpIcon, SchoolIcon } from 'lucide-react';
export function Benefits() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="beneficios" className="w-full bg-white py-20 px-4" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-4">
            Por que o Mega Pacote funciona?
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-5">
          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow duration-300" data-id="element-6">
            <div className="inline-flex p-4 rounded-full bg-red-100 mb-6" data-id="element-7">
              <ClockIcon className="h-8 w-8 text-red-700" aria-hidden="true" data-id="element-8" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-9">
              ⏱️ Economia de Tempo
            </h3>
            <p className="text-gray-600 leading-relaxed text-sm" data-id="element-10">
              Chega de passar domingo planejando aula. Tudo pronto para aplicar
              direto na sala.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow duration-300" data-id="element-11">
            <div className="inline-flex p-4 rounded-full bg-red-100 mb-6" data-id="element-12">
              <PackageIcon className="h-8 w-8 text-red-700" aria-hidden="true" data-id="element-13" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-14">
              📦 Conteúdo Completo
            </h3>
            <p className="text-gray-600 leading-relaxed text-sm" data-id="element-15">
              Material digital com planos, atividades e avaliações prontas para
              o ano letivo inteiro.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow duration-300" data-id="element-16">
            <div className="inline-flex p-4 rounded-full bg-red-100 mb-6" data-id="element-17">
              <TrendingUpIcon className="h-8 w-8 text-red-700" aria-hidden="true" data-id="element-18" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-19">
              📈 Progressão Pedagógica
            </h3>
            <p className="text-gray-600 leading-relaxed text-sm" data-id="element-20">
              Estruturado por ano e bimestre para garantir o avanço real dos
              alunos.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow duration-300" data-id="element-21">
            <div className="inline-flex p-4 rounded-full bg-red-100 mb-6" data-id="element-22">
              <SchoolIcon className="h-8 w-8 text-red-700" aria-hidden="true" data-id="element-23" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-24">
              🏫 Funciona em Qualquer Contexto
            </h3>
            <p className="text-gray-600 leading-relaxed text-sm" data-id="element-25">
              Ideal para escola pública, escola privada e professores
              independentes.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}